import { Grid } from '@material-ui/core'
import StandardTable from 'asterX-UI/Table/StandardTable'
import React, { useEffect } from 'react'
import { useContractStore } from 'context/ContractStore'
import { NotFound } from 'components/NotFound/NotFound'
import { useStyles } from './call-history.styles'
import { callHistoryColumns, callHistoryRows } from './const'

export const CallHistory = () => {
  const classes = useStyles()
  const {
    contractStore: { calls },
    contractStoreFunc
  } = useContractStore()

  useEffect(() => {
    contractStoreFunc.getCalls()
  }, [])

  const tableData = {
    columns: callHistoryColumns,
    rows: callHistoryRows(calls)
  }

  return (
    <Grid container className={calls?.length > 0 ? classes.wrapper : ''}>
      {calls?.length > 0 ? (
        <StandardTable
          tableData={tableData}
          btnStyle={{ backgroundColor: 'transparent', border: 'none', padding: 8, minWidth: 'auto' }}
        />
      ) : (
        <NotFound title="Нет звонков" />
      )}
    </Grid>
  )
}
